const socket = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {}
};

export default socket;
